// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"463":"6eff141f","768":"efe68ab3"}[chunkId] + ".css";
};